export default "__VITE_ASSET__D6u6CVRL__"